import { LazyLoadImage } from 'react-lazy-load-image-component';
import styled from 'styled-components';

import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';
import { BorderRadius } from '@r1-frontend/ui-react/tokens/borderRadius';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';
import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';

export const Wrapper = styled.div`
    grid-area: help;
    row-gap: 36px;
    height: min-content;
`;

export const ContentWrapper = styled.div`
    position: relative;
    height: fit-content;
    padding: 32px;
    background-color: ${COLORS.BgSurface};
    border-radius: ${BorderRadius.OuterBlockRadius};
    row-gap: 8px;

    @media (max-width: ${wideBreakpoints.mobile}) {
        padding: 24px;
    }
`;

export const TextWrapper = styled.div`
    margin-right: 146px;

    @media (max-width: ${wideBreakpoints.mobile}) {
        margin-right: 112px;
    }
`;

export const TextLink = styled.a`
    transition: 0.25s;
    ${FONTS.MediumS};
    color: ${COLORS.Link};
    
    &:hover {
        color: ${COLORS.TextPrimary};
    }
`;

export const ImageGirl = styled(LazyLoadImage)<{ src: string }>`
    position: absolute;
    right: 0;
    bottom: 0;
    width: 160px;
    height: 160px;
    border-bottom-right-radius: ${BorderRadius.OuterBlockRadius};

    @media (max-width: ${wideBreakpoints.mobile}) {
        width: 112px;
        height: 112px;
    }
`;
